<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
                <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater1">
      <b-table striped small  head-variant="light" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(inNum)="data">
          {{ Number(data.item.inNum).toFixed(4) }}
        </template>
        <template v-slot:cell(price)="data">
          {{ Number(data.item.price).toFixed(2) }}
        </template>
        <template v-slot:cell(costPrice)="data">
          {{ data.item.costPrice !== null && data.item.costPrice !== undefined ? Number(data.item.costPrice).toFixed(4) : '' }}
        </template>
<!--        <template v-slot:cell(archivesName)="data" style="'left':'80px';">-->
<!--          <div v-if="data.item.archivesName">{{ data.item.archivesName }}</div>-->
<!--          <div v-else>-</div>-->
<!--        </template>-->
<!--        <template v-slot:cell(materialData)="data" style="'left':'80px';">-->
<!--          <div v-if="data.item.materialName">{{ data.item.materialName }}/{{ data.item.materialModel?data.item.materialModel:'-' }}/{{ data.item.materialUnit }}</div>-->
<!--          <div v-else>-</div>-->
<!--        </template>-->
<!--        <template v-slot:cell(level)="data" style="'left':'80px';">-->
<!--          <van-tag plain size="medium" :type="data.item.materialName?'success':'warning'">{{data.item.materialName?'物料':'类别'}}</van-tag>-->
<!--        </template>-->
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'index' ?'30px': field.key === 'costPrice' ?'120px':'100px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(inNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'inNum', 4)}}</div>
        </template>
        <template v-slot:foot(amount)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amount', 4)}}</div>
        </template>
      </b-table>
<!--       <div>{{items}}</div>-->
    </div>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import {BTable} from 'bootstrap-vue'


export default {
  name: 'materDispose_Detail',
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'materialName', label: '物料名称'},
        {key: 'materialModel', label: '规格型号'},
        {key: 'materialUnit', label: '单位'},
        {key: 'inNum', label: '处置数量'},
        {key: 'price', label: '单价（元）'},
        {key: 'amount', label: '金额（元）'},
        {key: 'costPrice', label: '包装物料单价（元）'},
      ],
      items: [],
      dataList: [],
      businessId: '',
      searchForm: {
        deratedId: ''
      },
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        orders: []
      },
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data.materCenterInSubList
      // this.joint(["materialName", "materialModel", "materialUnit"])
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    // 合计计算
    sumNum(arr, key, n = 2) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(n, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

